import { baseAlert } from "./baseAlert";

/** Displays a SweetAlert prompting the user to confirm whether they want to cancel */
const loadingSpinnerAlert = (
  text: string = "",
  html: string = "",
  width: string = "150px",
) => {
  return baseAlert.fire({
    text: text,
    width: width,
    html: html,
    allowOutsideClick: false,
    didOpen: () => {
      baseAlert.showLoading();
    },
  });
};

export { loadingSpinnerAlert };
